module.exports = __webpack_public_path__ + "static/media/T13.feaca708.mp4";